import React, { PropsWithChildren, ReactNode, useCallback } from 'react';
import { noop } from 'lodash';

import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PartRequestBulkItemDto } from '../types';

import Button from '../../../core/components/button/Button';

interface StockBulkEditCellControlProps {
  row: PartRequestBulkItemDto;
  onEdit?: (row: PartRequestBulkItemDto) => void;
  hint?: ReactNode;
}

export const StockBulkEditCellControl = ({
  onEdit = noop, row, children, hint = 'Edit',
}: PropsWithChildren<StockBulkEditCellControlProps>) => {
  const handleClick = useCallback(() => {
    onEdit(row);
  }, [row, onEdit]);

  if (children) {
    return <div className="edit-cell">
      <Button type="text" size="small" icon={<FontAwesomeIcon icon={faPencilAlt} />} onClick={handleClick} />
      {children}
    </div>;
  }

  return <Button type="text" size="small" label={hint} icon={<FontAwesomeIcon icon={faPencilAlt} />} onClick={handleClick} />;
};
